import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=641cd7ab&scoped=true"
import script from "./OfferCard.vue?vue&type=script&lang=ts"
export * from "./OfferCard.vue?vue&type=script&lang=ts"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=641cd7ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641cd7ab",
  null
  
)

export default component.exports